/***********************
 * Theme provider
 * Used in ThemeDropDown.js
 ************************/

import React, {
  Suspense,
  createContext,
  useContext,
  useState,
  useLayoutEffect,
  useMemo,
} from "react"
import PropTypes from "prop-types"

const ThemeContext = createContext()

const ThemeProvider = ({ children }) => {
  const initialTheme = () => localStorage.getItem("theme")
  const [theme, setTheme] = useState(initialTheme)

  // Change theme
  const toggleTheme = t => {
    console.log("Change theme to: " + t)
    if (document.body) {
      document.body.dataset.layoutMode = t
      localStorage.setItem("theme", t)
      setTheme(t)
    }
  }

  const contextValue = useMemo(() => ({ theme, toggleTheme }), [theme])

  useLayoutEffect(() => {
    //console.log("Theme: " + theme)
    if (document.body) {
      if (theme == undefined) {
        document.body.dataset.layoutMode = "light"
      } else {
        document.body.dataset.layoutMode = theme
      }
    }
  }, [theme])

  return (
    <ThemeContext.Provider value={contextValue}>
      <Suspense
        fallback={
          <>
            <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
          </>
        }
      >
        {children}
      </Suspense>
    </ThemeContext.Provider>
  )
}

const useTheme = () => {
  const context = useContext(ThemeContext)
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider")
  }
  return context
}

ThemeProvider.propTypes = {
  children: PropTypes.any,
}

export { ThemeProvider, useTheme }
